import React from "react";
import { motion } from "framer-motion";
import { FaMusic, FaLightbulb, FaMicrophone, FaSmile } from "react-icons/fa";

export default function CoWyrozniaSection() {
  const cechy = [
    {
      icon: <FaMusic size={32} />,
      title: "Profesjonalna muzyka",
      desc: "Perfekcyjnie dobrane utwory – na każdą chwilę imprezy.",
    },
    {
      icon: <FaMicrophone size={32} />,
      title: "Prowadzenie z klasą",
      desc: "Wodzirej z doświadczeniem – elegancko i z humorem.",
    },
    {
      icon: <FaLightbulb size={32} />,
      title: "Nowoczesne efekty",
      desc: "Ciężki dym, dekoracje światłem, piana party i więcej.",
    },
    {
      icon: <FaSmile size={32} />,
      title: "Indywidualne podejście",
      desc: "Ty decydujesz, ja pomagam – razem tworzymy klimat.",
    },
  ];

  return (
    <section className="pt-16 sm:pt-24 pb-24 sm:pb-36 bg-zinc-100 text-black">
      <motion.div
        className="max-w-7xl mx-auto px-4 sm:px-6 text-center"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-3xl xs:text-4xl md:text-5xl font-bold mb-10 sm:mb-16 uppercase tracking-wide">
          Co mnie wyróżnia?
        </h2>
        <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-10">
          {cechy.map((item, i) => (
            <motion.div
              key={i}
              className="bg-white p-6 rounded-2xl shadow-2xl group relative text-center"
              style={{ boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.18), 0 1.5px 8px 0 #ff6600a0', transformOrigin: 'center' }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              whileHover={{ scale: 1.12, transition: { duration: 0.15 } }}
            >
              <div
                className="text-orange-500 mb-4"
                aria-hidden="true"
              >
                {item.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2 group-hover:text-orange-500 transition-colors duration-300">{item.title}</h3>
              <p className="text-zinc-600 text-sm group-hover:text-black/80 transition-colors duration-300">{item.desc}</p>
              <div className="absolute inset-0 rounded-2xl pointer-events-none group-hover:ring-4 group-hover:ring-orange-200/60 transition-all duration-300" />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
